<template>
<div class="chapter">
<div class="inner_page">
<h2 class="section"><a id="pt01_pt"></a>PART I </h2>
<h2 class="section1"><a id="pt02_pt"></a><i>Dependency versus Self-Reliance</i> </h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?4a9fea79